import styles from "../ClientList/ClientList.module.css";

export const ClientList = ({ headerRef, clientRowRef, scrolled }) => {
  return (
    <div className={styles.containerBox}>
      <div
        className={styles.headerDiv}
        ref={headerRef}
        data-id="clientListHeader"
      >
        <h3 className={`${styles.h3} ${scrolled.clientListHeader ? styles.animate : ""}`}>
          SOME OF OUR CLIENTS
        </h3>
      </div>
      <div
        className={`${styles.clientRow} ${
            scrolled.clientListRow ? styles.animate : ""
        }`}
        ref={clientRowRef}
        data-id="clientListRow"
      >
        <div className={`${styles.clientDiv} ${styles.americanAir}`}>
          American Airlines
        </div>
        <div className={`${styles.clientDiv} ${styles.alaskaAir}`}>
          Alaska Airlines
        </div>
        <div className={`${styles.clientDiv} ${styles.jetsuite}`}>
          <span className={styles.jetRed}>jet</span>
          <span className={styles.jetGrey}>suite</span>
        </div>
        <div className={`${styles.clientDiv} ${styles.ipa}`}>IPA</div>
      </div>
    </div>
  );
};
